import aboutImage1 from "../../assets/about/home.png";
import aboutImage2 from "../../assets/about/aboutimg1.jpg";
import aboutImage3 from "../../assets/about/aboutimg2.jpg";
import HeaderSection from "../../common/HeaderSection/Header";
import StoriesOfImpact from "../../common/Story/Story";
import Donate from "../../common/Donation/Donate";
import Quote from "../../common/Quote/Quote";
import counsellor from "../../assets/counsellor.png";
import nonProfit from "../../assets/about/non-profit.png";
import ContactForm from "../../common/ContactForm/Contact";
import DonateToFood from "../../common/DonateToFood/DonateFood";
import homepage from "../../assets/about/homepage.jpg";
import "./About.css";
import CarouselPage from "../../common/Carousel/CarouselPage";

const About = () => {
  const carouselImages = [
        { src: aboutImage1, alt: "First image ",style: { height: "600px", width: "100%", objectFit: "cover" } },
        { src: aboutImage2, alt: "Second image",style: { height: "600px", width: "100%", objectFit: "cover" } },
        { src: aboutImage3, alt: "Third image" ,style: { height: "600px", width: "100%", objectFit: "cover" }},
      ];
  return (
    <div className="about-container home-image">
      <CarouselPage images={carouselImages} className="carousel-container" />
      <HeaderSection
      image={aboutImage1}
      imageStyle={{marginTop: "3rem"}}
        text="About Us"
        longtext="“  ACT AS IF IT MAKES DIFFERENCE, IT WILL “"
      />

      <div className="honoury-counsellor">
        <h1 className="title">Meet our Honoury Counsellor</h1>
        <div className="counsellor-container">
          <img
            className="counsellor-image"
            src={counsellor}
            alt="honoury counsellor"
          />
          <div className="counsellor-details">
            <h3>Counsellor</h3>
            <h3>Mrs Virender Kaur Mehta</h3>
          </div>
        </div>
      </div>
      <Quote text="“ “Happiness doesn’t result from what we get, but from what we give ” “" />
      <div className="non-profit">
        <div className="non-profit-header">
          <h1>E-Techno Is The Non-Profitable Organization</h1>
        </div>
        <div className="non-profit-content">
          <div className="non-profit-image">
            <img src={nonProfit} alt="Child" />
          </div>
          <div className="non-profit-text">
            <h2>E-Techno Educational & Research Society</h2>
            <p>
              We work to protect the rights of every child, especially the most
              disadvantaged and those hardest to reach. In more than 190
              countries and territories, we do whatever it takes to help
              children survive, thrive, and fulfill their potential. We provide
              and advocate for education, health, and nutrition services,
              protect children from violence and abuse, bring clean water and
              sanitation to those in need, and keep them safe from climate
              change and disease.
            </p>
          </div>
        </div>
        <div className="non-profit-mission-vision">
          <div className="mission">
            <h3>Our Mission</h3>
            <p>
              E-Techno is mandated by the Indian Government to
              advocate for the protection of children's rights, to help meet
              their basic needs and to expand their opportunities to reach their
              full potential.
            </p>
          </div>
          <div className="vision">
            <h3>Our Vision</h3>
            <p>
              Child Protection & Child Education. Every child has the right to
              live free from violence, exploitation and abuse.
            </p>
          </div>
        </div>
      </div>

      <DonateToFood image={homepage} style={{width: "107%"}}/>
      <Donate />
      <StoriesOfImpact />
      <ContactForm />
    </div>
  );
};

export default About;
